import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getCurrencySymbol } from '../../../../../utils/currency-symbol.util';
import { hasQuantityInLabel } from '../../../../../utils/invoice-display.util';

export interface NextInvoicePreviewLineItem {
  /** USAGE: this period's per-order charge so far, an estimate (FNF-1284). ADDON lines are
   * add-ons so far too, billed for the days they were active (FNF-1507). */
  type: 'PLAN' | 'ADDON' | 'USAGE';
  description: string;
  quantity: number;
  amountCents: number;
}

export interface NextInvoicePreviewData {
  periodStart: number;
  periodEnd: number;
  amountDueCents: number;
  currency: string;
  lineItems: NextInvoicePreviewLineItem[];
}

@Component({
  selector: 'app-next-invoice-preview',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './next-invoice-preview.component.html',
  styleUrl: './next-invoice-preview.component.css',
})
export class NextInvoicePreviewComponent {
  readonly dialogRef = inject(MatDialogRef<NextInvoicePreviewComponent>);
  readonly data = inject<NextInvoicePreviewData>(MAT_DIALOG_DATA);
  protected readonly getCurrencySymbol = getCurrencySymbol;
  protected readonly hasQuantityInLabel = hasQuantityInLabel;

  formatDate(seconds: number): string {
    if (seconds === null || seconds === undefined || isNaN(seconds)) {
      return '';
    }
    return new Date(seconds * 1000).toLocaleDateString('en-US', {
      timeZone: 'UTC',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  close() {
    this.dialogRef.close();
  }
}
